import MyModal from 'components/MyModal';
import { Form, Formik } from 'formik';
import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useWebHook } from 'v2/components/Pages/Webhook/context';
import webhookService from 'v2/services/webhook';

import type { IFieldsWebHook, IWebHookList } from 'v2/interfaces/webhook/webhook';

import Fields from './Fields';
import styles from './styles';
import { createWebhookSchema } from './validations';

import type { FormikProps } from 'formik';

interface IProps {
  open: boolean;
  webhook: IWebHookList;
  close: () => void;
}

const ModalEdit = memo(({ open, webhook, close }: IProps) => {
  const { updateList } = useWebHook();
  const classes = styles();

  const onSubmit = useCallback(
    (values: IFieldsWebHook, { setSubmitting }: FormikProps<IFieldsWebHook>) => {
      setSubmitting(true);

      webhookService
        .editURL(webhook?._id, values.name, values.product, values.url)
        .pipe()
        .subscribe(() => {
          toast.success('Webhook atualizado com sucesso');
          updateList();
          close();
        }, toast.error);
    },
    [close, updateList, webhook]
  );

  const onReset = useCallback(() => {
    close();
  }, [close]);

  const initialValues: IFieldsWebHook = {
    name: webhook?.description,
    product: webhook?.product_id,
    url: webhook?.url,
    type: webhook?.type,
  };

  if (!open) {
    return null;
  }

  return (
    <MyModal title='Editar Webhook' subTitle={<>Edite as informações do Webhook.</>} hasActive closeModal={() => close()}>
      <div className={classes.form}>
        <Formik validateOnBlur initialValues={initialValues} validationSchema={createWebhookSchema} onSubmit={onSubmit} onReset={onReset}>
          {() => (
            <Form>
              <Fields />
            </Form>
          )}
        </Formik>
      </div>
    </MyModal>
  );
});

export default ModalEdit;
